/**
 *
 * Asynchronously loads the component for GoalDetails
 *
 */

import { lazyLoad } from 'utils/loadable';

export const GoalDetails = lazyLoad(
  () => import('./index'),
  module => module.GoalDetails,
);
